// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable____i7K","large":"styles_large__3euaf"};